// packages/eden-appearance/src/components/modes.js
var appearanceStyles = {};
appearanceStyles.light = {};
appearanceStyles.dark = {};
var getAllModeStyles = (mode) => {
  const curMode = appearanceStyles[mode];
  const appearanceString = Object.keys(curMode).map(
    (key) => `${key}: ${curMode[key]};`
  ).join(`
`);
  return appearanceString;
};
var sendUpdate = (name, values) => {
  appearanceStyles.light[name] = values.light;
  appearanceStyles.dark[name] = values.dark;
};
export {
  getAllModeStyles,
  sendUpdate
};
